import { urls } from "./urls";
import countryCodes, { DEFAULT_COUNTRY_CODE } from "./country-codes";
import { paths } from "./paths";
import { facilityTypes } from "./facility-types";
import { radiusOptions, defaultRadiusOption } from "./radius-options";
import { patterns } from "./regexp-patterns";
import { providerSpecialties } from "./find-providers";
import { warningMessageType } from "./warning-message-type";

const abortControllerKey = Symbol("abortControllerKey");

export const constants = {
  openTokUrl: "https://static.opentok.com/v2/js/opentok.min.js",
  urls,
  countryCodes,
  DEFAULT_COUNTRY_CODE,
  paths,
  abortControllerKey,
  facilityTypes,
  radiusOptions,
  defaultRadiusOption,
  patterns,
  providerSpecialties,
  warningMessageType
};
